"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_select_1 = __importDefault(require("react-select"));
const SelectWrapper_1 = __importDefault(require("../SelectWrapper"));
const styles_1 = __importDefault(require("./styles"));
// The default CT Select is just a CT-skinned version of react-select
const Select = props => (react_1.default.createElement(SelectWrapper_1.default, Object.assign({}, props, { styles: Object.assign(Object.assign({}, props.styles), styles_1.default), selectedSelect: react_select_1.default })));
exports.default = Select;
Select.propTypes = {
    styles: prop_types_1.default.object,
};
